export default {
  SET_LISTA_TOAST (state, listaToast) {
    state.listaToast = listaToast
  },

  SET_ITEM_SELECIONADO_ID (state, id) {
    state.itemSelecionadoID = id
  },

  SET_LISTA_ITEMS_EXIBIDOS (state, listaNova) {
    state.listaNotificacoesExibidas = listaNova
  }
}
